import React, {useCallback, useEffect, useRef, useState} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {
  SIDEBAR_BUTTONS,
  SIDEBAR_BUTTONS_MENU,
  SIDEBAR_TYPE_AREA_BUTTONS,
  SIDEBAR_HIDDEN_BUTTONS, MEASURE_UNITS
} from "../../constants";
import {setSQFTActiveButton, setSQFTMenuOpened, setSQFTMenuOpenedLock} from "../../../../actions/sqftMenuFunctions";
import {useOutsideClick} from "../../../../misc/helperHooks";
import config from "../canvas/store/sqftConfig";
import ManualCalculateSwitcher from "./menuSwitchers/ManualCalculateSwitcher";
import SlabToolSwitcher from "./menuSwitchers/SlabToolSwitcher";
import {clearAllMenusEvents} from "../canvas/core/workspace/workspaceEvents";
import sqftEventManager from "../canvas/store/sqftEventManager";
import {getIsSFTAreaGroup} from "../../helpers/sqftNavigationHelper";
import Config from "../../../../config";
import sqftConfig from "../canvas/store/sqftConfig";

const SqftNavAside = (props) => {
  const {menuOpened, menuOpenedLock, activeButton, setSQFTMenuOpened, setSQFTMenuOpenedLock, setSQFTActiveButton,
    fabricatorData, isMobile} = props;

  const dropdownElement = useRef(null);
  const isSFTAreaGroup = getIsSFTAreaGroup();
  const buttons = isSFTAreaGroup ? SIDEBAR_TYPE_AREA_BUTTONS : SIDEBAR_BUTTONS
  const [sideBarButtons, setSideBarButtons] = useState(buttons);

  useOutsideClick(dropdownElement, (event) => {
    const disallowClasses = [".sidebar", ".sidebar2", ".side", ".expanded", ".full-screen-wrapper"];
    const menuThatStaysOpened = [
      SIDEBAR_HIDDEN_BUTTONS.mitered,
      SIDEBAR_HIDDEN_BUTTONS.toolWaterfall,
      SIDEBAR_HIDDEN_BUTTONS.toolUnderlayment,
    ]
    if (!disallowClasses.some(cls => event.target.closest(cls))) {
      if (menuOpenedLock) {
        setSQFTMenuOpenedLock(false); // lock menu for one click
      } else {
        if (menuOpened !== ""
          && !menuThatStaysOpened.includes(menuOpened)
        ) {
          setSQFTMenuOpened("");
        }
      }
    }
  }, true);

  const handleButtonClick = (button) => {
    clearAllMenusEvents();
    let newMenuButton = button.menu

    //close if already opened
    if (activeButton === newMenuButton && SIDEBAR_BUTTONS_MENU.delete === newMenuButton) {
      newMenuButton = SIDEBAR_BUTTONS_MENU.move
    }
    setSQFTActiveButton(newMenuButton);
    config.workspace.menuItemActive = newMenuButton;

    //open submenu
    if (button.hasMenu) {
      const newMenu = menuOpened === newMenuButton
        ? "" // same button click
        : newMenuButton;
      setSQFTMenuOpened(newMenu);
    }

    //additional events on click
    switch (newMenuButton) {
      case SIDEBAR_BUTTONS_MENU.delete:
        sqftEventManager.setCursor("delete", self, true);
        break;
    }
  };

  const getSubMenuActiveButton = useCallback((sidebarButton, activeButton) => {
    let subMenuActiveButton = null
    if (sidebarButton.subMenu) {
      subMenuActiveButton = Object.keys(sidebarButton.subMenu).find(submenuButton => submenuButton === activeButton)
    }

    return subMenuActiveButton
  }, []);

  const setNavigationDisplayButton = useCallback((activeButton) => {
    const preparedSidebarButtons = [];
    buttons.forEach((sidebarButton) => {
      const subMenuActiveButton = getSubMenuActiveButton(sidebarButton, activeButton);
      const preparedButton = {...sidebarButton};
      if (subMenuActiveButton) {
        preparedButton.buttonToDisplay = activeButton
        if (!sidebarButton.shouldHardcodeMessage) {
          preparedButton.message = "sqft.navigation.submenu." + activeButton
        }
      }

      // Remove Summary for the metric
      if (preparedButton.menu === "summary" && sqftConfig.measureUnit === MEASURE_UNITS.Metric) {
        return
      }
      preparedSidebarButtons.push(preparedButton);
    })
    setSideBarButtons(preparedSidebarButtons)
  }, [getSubMenuActiveButton, buttons]);

  useEffect(() => {
    setNavigationDisplayButton(activeButton);
  }, [activeButton, getSubMenuActiveButton, setNavigationDisplayButton])

  useEffect(() => {
    setSQFTActiveButton("");
  }, [setSQFTActiveButton])

  // const enableSideBar = () => {
  //   const newVisible = !menuVisible;
  //   setSQFTMenuOpened(newVisible);
  //   setTimeout(() => {
  //     newVisible
  //       ? window.addEventListener('click', handleWrapperBlur)
  //       : window.removeEventListener('click', handleWrapperBlur)
  //   }, 0)
  // };

  return (
    <aside className="sidebar" ref={dropdownElement}>
      <div className="sidebar-buttons">
        <div className="sidebar-buttons--top">
          {sideBarButtons.map((item, index) => {
            const isActive = activeButton === (item.buttonToDisplay ? item.buttonToDisplay : item.menu);
            const classNames = "button "
              + "button--" + (item.buttonToDisplay ? item.buttonToDisplay : item.menu)
              + (item.hasMenu ? " button--parent" : "")
              + (isActive ? " button--active" : "");
            return (
              <button key={index}
                      className={classNames}
                      onClick={() => handleButtonClick(item)}
                      title={item.title}>
                <span className="button-text">
                  <FormattedMessage id={item.message}/>
                </span>
                <span className={item.additionalClassNames}/>
              </button>
            )
          })}
        </div>
        <div className="sidebar-buttons--bottom-mobile">
          <div className="sidebar-separator hide-mobile"/>
          <ManualCalculateSwitcher overlay={false} sideBarButtons={sideBarButtons}/>
          {(fabricatorData.settings.showSlabMode || Config.isDevMode())  && !isMobile ? <SlabToolSwitcher overlay={false} /> : null}
        </div>
      </div>
    </aside>
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  menuOpenedLock: store.sqftMenuState.menuOpenedLock,
  activeButton: store.sqftMenuState.activeButton,
  fabricatorData: store.fabricatorState,
  isMobile: store.serverState.isMobile,
});

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTMenuOpenedLock,
  setSQFTActiveButton,
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavAside);
